import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        conf: {},
        profile: {},
        fromAppMobile: false,
        meetup: null,
        community: null,
        communityStatsData: null,
        meetupsStatsData: null,
        invitations: [],
    meetupFilters:  null,
    footer: {}
    },
    getters: {
        conf: (state) => {
            return state.conf;
        },
        community: (state) => {
            return state.community
        },
        profile: (state) => {
            return state.profile;
        },
        isFromAppMobile: (state) => {
            return state.fromAppMobile;
        },
        meetup: (state) => {
            return state.meetup;
        },
        communityStatsData: (state) => {
            return state.communityStatsData;
        },
        meetupsStatsData: (state) => {
            return state.meetupsStatsData;
        },
        invitations: (state) => {
            return state.invitations;
        },
        meetupFilters: (state) => {
        return state.meetupFilters;
        },
        footer: (state) => {
            return state.footer;
            }
    },
    mutations: {
        updateConf: (state, conf) => {
            state.conf = conf;
        },
        updateProfile: (state, profile) => {
            state.profile = profile;
        },
        setIsFromAppMobile: (state, value) => {
            state.fromAppMobile = value;
        },
        setMeetup: (state, meetup) => {
            state.meetup = meetup;
        },
        setCommunity: (state, community) => {
            state.community = community;
        },
        setInvitations: (state, invitations) => {
            state.invitations = invitations;
        },
        setCommunityStatsData: (state, data) => {
            state.communityStatsData = data;
        },
        setMeetupsStatsData: (state, data) => {
            state.meetupsStatsData = data;
        },
        setMeetupFilters: (state, meetupFilters) => {
        state.meetupFilters = meetupFilters;
        },
        setFooter: (state, footer) => {
            state.footer = footer;
            }
    },
});

export default store;